import css from './resultPane.module.scss';

import { memo } from 'react';

import {
  TRepetitionAction,
  TRepetitionActionType,
  calcShiftInHours,
} from 'core/helpers/repetition';

type TProps = {
  action: TRepetitionAction;
  word: TWord;
  exercise: TExercise;
};

type TLabel = { timeLabel: string; timeValue: number };
const getLabel = (distanceInHours: number): TLabel => {
  if (distanceInHours >= 24 * 99) {
    return {
      timeLabel: 'm',
      timeValue: Math.round(distanceInHours / (24 * 30)),
    };
  }
  if (distanceInHours >= 24) {
    return { timeLabel: 'd', timeValue: Math.round(distanceInHours / 24) };
  }
  return { timeLabel: 'h', timeValue: Math.round(distanceInHours) };
};

const ButtonLabel: React.FC<TProps> = ({ action, word, exercise }) => {
  switch (action.type) {
    case TRepetitionActionType.reset:
      return <>{'reset'}</>;
    case TRepetitionActionType.skip:
      return <>{'skip'}</>;
    case TRepetitionActionType.shift: {
      const { shiftInHours, isBigger } = calcShiftInHours(
        exercise,
        word,
        action.factor
      );
      const label = getLabel(shiftInHours);
      return (
        <>
          <span className={css.shiftValue} data-bigger={isBigger}>
            +{label.timeValue}
          </span>
          {label.timeLabel}
        </>
      );
    }
  }
};

export default memo(ButtonLabel);
